<ng-container *ngIf="transactionalDataState$ | async as state">
    <div class="sale-container mat-elevation-z8">
        <div class="table-header">

            <mat-form-field style="width: 20%" subscriptSizing="dynamic">
                <mat-label>{{ "app.external-data.daterange.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="datefilterFormGroup" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">


                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.sale.articleNr.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.articleNr }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="costUnit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.sale.cost-unit.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="state.costUnitLookup[element.articleNr] !== undefined; else displayArticleNr">
                            {{state.costUnitLookup[element.articleNr].name}}
                        </ng-container>
                        <ng-template #displayArticleNr>
                           [{{element.articleNr}}]
                        </ng-template>
                    </td>
                </ng-container>



                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.sale.date.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.date | date: 'dd.MM.yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="priceCt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.sale.price.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.priceCt / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.sale.amount.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.amount | number: '1.0-2' : 'de-DE'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="measureUnit">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.sale.measureUnit.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.measureUnit.name">
                        <ng-container *ngIf="element.measureUnit.shortName != null; else displayFullName">
                            {{element.measureUnit.shortName}}
                        </ng-container>
                        <ng-template #displayFullName>
                            {{element.measureUnit.name}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="priceCtPerMeasureUnit">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.sale.priceCtPerMeasureUnit.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.priceCtPerMeasureUnit / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.saleColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.saleColumns;"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
